function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#009fb3"
}, React.createElement("path", {
  d: "m.820312 16.5083c.711378-3.7924 4.040068-6.66213 8.039018-6.66213 3.99897 0 7.32767 2.86973 8.03907 6.66213-2.0076 2.1486-4.8665 3.4917-8.03907 3.4917-3.17255 0-6.03141-1.3431-8.039018-3.4917z"
}), React.createElement("path", {
  d: "m13.0901 5.0513c0 2.33658-1.8942 4.23076-4.23077 4.23076-2.33659 0-4.23077-1.89418-4.23077-4.23076 0-2.33659 1.89418-4.230774 4.23077-4.230774 2.33657 0 4.23077 1.894184 4.23077 4.230774z"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 17 20",
    width: 17,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.8113dd6d.svg";
export { ForwardRef as ReactComponent };